import { createFileRoute } from "@tanstack/react-router";
import { getForumPage } from "@/features/community/records";
import { ForumPage, communityHead } from "@/features/community";
import {
  CommunityPageLoading,
  CommunityPageError,
} from "@/features/community/navigation";

export const Route = createFileRoute("/_site/unlisted/$coworld/forum/")({
  loader: ({ location, abortController }) =>
    getForumPage({
      data: { href: location.href },
      signal: abortController.signal,
    }),
  head: ({ loaderData }) => communityHead(loaderData?.metadata),
  pendingComponent: () => <CommunityPageLoading title="Forum" />,
  errorComponent: ({ error, reset }) => (
    <CommunityPageError error={error} retry={reset} />
  ),
  component: () => <ForumPage data={Route.useLoaderData()} />,
});
